// extracted by mini-css-extract-plugin
export default {"HomePage":"HomePage-module--HomePage--3b_DE","testimonials":"HomePage-module--testimonials--3EU39"};